module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f22d5ea0ef6a46b2a4a174fed722c396.svg";